/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceGroupDetailsBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return ResourceGroupDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<ResourceGroupDetailsBase>): ResourceGroupDetailsBase {
        let obj = Object.assign(new ResourceGroupDetailsBase(), model);
        ResourceGroupDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceGroupDetailsBase>): ResourceGroupDetailsBase {
        if (!model) return null;
        return ResourceGroupDetailsBase.newInstance(<ResourceGroupDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceGroupDetailsBase) {
        if (!obj) return;

        models.ResourceGroupDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceGroupDetailsBase): boolean {
        switch (obj.type)
        {
            case "ResourceGroupDetailsForAws":
                Object.setPrototypeOf(obj, models.ResourceGroupDetailsForAws.prototype);
                break;
            case "ResourceGroupDetailsForAzure":
                Object.setPrototypeOf(obj, models.ResourceGroupDetailsForAzure.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ResourceGroupDetailsBase)[] {
        return [
            models.ResourceGroupDetailsForAws,
            models.ResourceGroupDetailsForAzure,
        ];
    }

    fixupFields() {
    }

    /**
     * Unique Id
     */
    resource_group_id: string;

    /**
     * Display Name
     */
    name: string;

    /**
     * Description
     */
    description: string;

}
